import { Field } from "../../components/ComponentForm";

export const fields: Field[] = [ 
  { name: "nomeCliente", label: "Nome do Cliente", type: "text", required: true, placeholder: "Ex: João da Silva" },
  { name: "telefone", label: "Telefone", type: "text", placeholder: "Ex: (11) 99999-9999" },
  { name: "modeloMoto", label: "Modelo da Moto", type: "text", placeholder: "Ex: Honda CG 160" },

  { name: "placa", label: "Placa", type: "text", placeholder: "Ex: ABC-1234" },
  {
    name: "tipoConserto",
    label: "Tipo de Conserto",
    type: "select",
    options: ["Manutenção", "Revisão", "Troca de Peças", "Elétrico", "Troca de Óleo", "Freio", "Suspensão", "Retifica de Motor" ],
    required: true
  },

  { name: "valorConserto", label: "Valor do Conserto (R$)", type: "number", required: true, placeholder: "Ex: 150.00" },
  
  { name: "mecanico", label: "Nome do Mecânico", type: "text", placeholder: "Ex: José da Silva" },
  { name: "maoDeObra", label: "Mão de Obra do Mecânico (R$)", type: "number" },
  { name: "dataEntrada", label: "Data de Entrada", type: "date", required: true },
  { name: "dataSaida", label: "Data de Saída", type: "date"},
  {name: "desconto", label: "Desconto (R$)", type: "number", placeholder: "Ex: R$ 20.00" },

  { name: "foto", label: "Foto", type: "file" },
  { name: "pecaLoja_extra", label: "Usou peça da loja?", type: "checkbox" },

  {
    name: "status",
    label: "Status do Serviço",
    type: "select",
    options: ["Pendente", "Em Andamento", "Concluído"],
    required: true
  },

  { name: "observacoes", label: "Observações", type: "textarea", $fullWidth: true },
  {
  name: "nivelGasolina",
  label: "Nível de Combustível",
  type: "fuel"
}
];